/**
 * Cleans offline cache by evicting low-priority entity types.
 */

import { getEntityBreakdown, deleteEntitiesByType } from '../offline/sqlite-store.service';
import { getCleanupPriority } from '../cache/cache-policy.service';

export interface CleanupResult {
  entityTypesCleaned: string[];
  bytesFreed: number;
}

/**
 * Evicts entities from lowest-priority types until targetBytes is freed or no more evictable data.
 */
export async function runCleanup(targetBytes: number): Promise<CleanupResult> {
  const breakdown = await getEntityBreakdown();
  if (breakdown.length === 0) return { entityTypesCleaned: [], bytesFreed: 0 };

  const withPriority = breakdown
    .map((row) => ({
      ...row,
      priority: getCleanupPriority(row.entity_type),
    }))
    .sort((a, b) => a.priority - b.priority);

  const entityTypesCleaned: string[] = [];
  let bytesFreed = 0;

  for (const row of withPriority) {
    if (bytesFreed >= targetBytes) break;
    if (row.size_bytes > 0) {
      await deleteEntitiesByType(row.entity_type);
      entityTypesCleaned.push(row.entity_type);
      bytesFreed += row.size_bytes;
    }
  }

  return { entityTypesCleaned, bytesFreed };
}
